import React, {Component} from 'react';
import styles from './GalleryItem.css';
import PropTypes from "prop-types"
import {TypeImage} from "../../constants/consts-prop-types"
import {Icon, LIB} from "../../constants/consts-types"
import Sticker from "../Sticker/Sticker"
import Svg from "../Svg/Svg"
import {loadImage} from "../../services/service-image-loader"

class GalleryItem extends Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    data: TypeImage,
    isDesktop: PropTypes.bool.isRequired,
    inLastRow: PropTypes.bool.isRequired,
    onImageClick: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      imageSrc: null
    }

    this.onImageLoaded = this.onImageLoaded.bind(this)
    this.getImageHeight = this.getImageHeight.bind(this)
    this.onImageClick = this.onImageClick.bind(this)
  }

  componentDidMount() {
    loadImage(this.props.data.image_url, this, this.onImageLoaded)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getImageHeight)
  }

  componentDidUpdate(prevProps) {
    if(this.props.data.image_url !== prevProps.data.image_url) {
      loadImage(this.props.data.image_url, this, this.onImageLoaded)
    }
  }

  onImageLoaded() {
    if(this.props.equalizeHeightsInRow) {
      window.addEventListener('resize', this.getImageHeight)
      this.getImageHeight()
    }
  }

  getImageHeight() {
    if(this.props.equalizeHeightsInRow) this.props.equalizeHeightsInRow(this.props.index, this.image.offsetHeight)
  }

  onImageClick(event) {
    const {data} = this.props
    const {link} = data
    if(link) return false

    event.preventDefault()
    if(this.props.onImageClick) this.props.onImageClick(this.props.index)
  }

  render() {
    const {isDesktop, data, onImageClick, inLastRow} = this.props
    const {imageContainerHeightEqualized, caption, link, iiif_url} = data
    const {imageSrc} = this.state

    const styleFigure = {
      marginBottom: inLastRow ? 0 : ''
    }

    const styleImageContainer = {
      height: isDesktop ? `${imageContainerHeightEqualized}px` : 'auto',
    }

    const linkProps = {
      ...(link && {
        target: '_blank',
        rel: 'noopener'
      })
    }

    return (
      <figure className={styles.GalleryItem} style={styleFigure}>
        <div
          className={styles.imageContainer}
          style={styleImageContainer}
        >
          <a
            aria-label={onImageClick && !link ? LIB.open_in_fullscreen : ''}
            href={link ? link : ''}
            className={styles.imageLink}
            onClick={this.onImageClick}
            {...linkProps}
          >

            <img
              ref={node => this.image = node}
              src={imageSrc}
              alt={''}
              className={styles.image}
              style={{opacity: imageSrc ? 1 : 0}}
            />

            {iiif_url &&
            <Sticker className={styles.sticker}>
              <span>Zoom</span>
              <Svg id={Icon.IIIF}/>
            </Sticker>
            }
          </a>
        </div>
        <figcaption className={styles.caption} dangerouslySetInnerHTML={{__html: caption}}/>
      </figure>
    )
  }
}

export default GalleryItem;



// WEBPACK FOOTER //
// ./src/components/GalleryItem/GalleryItem.js